import { useEffect, useState } from 'react';
import { Field, Form, Formik } from 'formik';
import { TextField } from '@material-ui/core';
import Modal from '../../common/Modals/Modal';

const PhotoModalSetDisaproovedReason = ({
  toggleShow,
  show,
  onSubmit,
  setReason,
  tempAproovedPhoto,
  baseUrl,
}) => {
  const [renderedIndex, setRenderedIndex] = useState(0);

  useEffect(() => {
    if (tempAproovedPhoto === 0) {
      setRenderedIndex(0);
    }
  }, [tempAproovedPhoto]);
  return (
    <Formik initialValues={{}} onSubmit={onSubmit}>
      {({ handleSubmit, values, setFieldValue }) => (
        <Form>
          <Modal
            toggleShow={() => {
              setRenderedIndex(0);
              setFieldValue('reason', '');
              toggleShow();
            }}
            show={show}
            title={'Отказ в публикации фотографии'}
            textBtnOk={'Применить'}
            btnOkAction={() => {
              let reason = !!values.reason
                ? values.reason
                : 'Оператор не указал причину, свяжитесь с тех-поддержкой';
              if (renderedIndex + 1 >= tempAproovedPhoto.length) {
                setReason(renderedIndex, reason);
                setRenderedIndex(0);
                setFieldValue('reason', '');
                handleSubmit();
              } else {
                setReason(renderedIndex, reason);
                setRenderedIndex((prev) => prev + 1);
                setFieldValue('reason', '');
              }
            }}
          >
            <div className='row'>
              <div className='col-12 mb-3'>
                <span>
                  Вы уверены, что хотите отказать в публикации фото? (отельер
                  будет оповещен, обязательно укажите причину отказа)
                </span>
              </div>
              <div>
                {!tempAproovedPhoto.length ? null : (
                  <div className='col-12'>
                    <div className='d-flex justify-content-center'>
                      <img
                        className='delete-photo__img'
                        src={baseUrl + tempAproovedPhoto[renderedIndex].src}
                        alt=''
                        style={{
                          width: '70%',
                          marginBottom: '1rem',
                          borderRadius: '0.5rem',
                        }}
                      />
                    </div>
                    <div
                      className='d-flex justify-content-center'
                      style={{
                        marginBottom: '1rem',
                      }}
                    >
                      Фото {renderedIndex + 1} из {tempAproovedPhoto.length}
                    </div>
                    <div className='col-12'>
                      <Field name='reason'>
                        {({ field }) => (
                          <TextField
                            label='Причина отказа *'
                            multiline
                            name={field.name}
                            onChange={field.onChange}
                            fullWidth
                            minRows={5}
                            variant='outlined'
                            inputProps={{ maxLength: 2000 }}
                            helperText='* - обязательно для заполнения!'
                            value={values.reason}
                          />
                        )}
                      </Field>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Modal>
        </Form>
      )}
    </Formik>
  );
};
export default PhotoModalSetDisaproovedReason;
